import AddIcon from "@mui/icons-material/Add";
import {Fragment, useState} from "react";
import { Button } from "@mui/material";
import CompanyCuitSyncDialog from "./CompanyCuitSyncDialog";

interface NewCompanyProps {
    hasCompany?: boolean
}
const NewCompany = ({hasCompany} : NewCompanyProps) => {
    const [open, setOpen] = useState<boolean>(false)

    return (
        <Fragment>
            {
                !hasCompany &&
                <Button color='primary' variant='contained' onClick={() => { setOpen(true) }} startIcon={<AddIcon />}>
                    Añadir empresa
                </Button>
            }
            <CompanyCuitSyncDialog open={open}
                onClose={() => { 
                    setOpen(false)
                }}
                subtitle={'Para cargar su empresa, por favor ingrese el CUIT/CUIL de la misma. Los datos serán traídos desde la base de datos de AFIP.'}
                saveClient
            />
        </Fragment>
    )
}


export default NewCompany